export default "__VITE_ASSET__Cby$pwhC__"